import Layout from "@/views/iori/layout/Layout";

const ZiGuiRouter = [
  // 秭归 -->冷源
  {
    path: "/coldWaterSystem",
    component: Layout,
    redirect: "/coldWaterSystem/index",
    children: [
      {
        path: "index",
        name: "coldWaterSystem",
        component: () => import("@/views/business/base/coldWaterSystem/index"),
      },
    ],
  },
  // 秭归 -->热源
  {
    path: "/heatSource",
    component: Layout,
    redirect: "/heatSource/index",
    children: [
      {
        path: "index",
        name: "heatSource",
        component: () => import("@/views/business/base/heatSource/index"),
      },
    ],
  },
  // 秭归 -->给水
  {
    path: "/giveWater",
    component: Layout,
    redirect: "/giveWater/index",
    children: [
      {
        path: "index",
        name: "giveWater",
        component: () => import("@/views/business/base/giveWater/index"),
      },
    ],
  },
  // 消防系统
  {
    path: "/fireFightingSystem",
    component: Layout,
    redirect: "/fireFightingSystem/index",
    children: [
      {
        path: "index",
        name: "FireFightingSystem",
        component: () =>
          import("@/views/business/base/fireFightingSystem/map"),
      },
      {
        path: "floor",
        name: "FireFightingSystemFloor",
        component: () =>
          import("@/views/business/base/fireFightingSystem/index"),
      },
    ],
  },
  // 电梯系统
  {
    path: "/elevatorSystem",
    component: Layout,
    redirect: "/elevatorSystem/index",
    children: [
      {
        path: "index",
        name: "ElevatorSystem",
        component: () => import("@/views/business/base/elevatorSystem/map"),
      },
    ],
  },
  // 照明系统
  {
    path: "/illuminationSystem",
    component: Layout,
    redirect: "/illuminationSystem/index",
    children: [
      {
        path: "index",
        name: "illuminationSystem",
        component: () => import("@/views/business/qy/illuminationSystem/index"),
      },
      {
        path: "xifu",
        name: "illuminationSystemXifu",
        component: () => import("@/views/business/qy/illuminationSystem/xifu"),
      }
    ],
  },
  //公共广播
  {
    path: "/broadcasting",
    component: Layout,
    redirect: "/broadcasting/publicBroadcasting",
    children: [
      {
        path: "publicBroadcasting",
        name: "Broadcasting",
        component: () => import("@/views/business/base/broadcasting/index"),
      },
    ],
  },
  //信息发布
  {
    path: "/informationRelease",
    component: Layout,
    redirect: "/informationRelease/index",
    children: [
      {
        path: "index",
        name: "informationRelease",
        component: () =>
          import("@/views/business/base/informationRelease/index"),
      },
    ],
  },
  // 首页
  {
    path: "/zg/home",
    name: "ZgHome",
    component: () => import("@/views/business/zg/index"),
    meta: {title: '首页'}
  },
  // 变配电
  {
    path: "/distributionElectricity",
    component: Layout,
    redirect: "/distributionElectricity/index",
    // 一期
    children: [
      {
        path: "index",
        name: "distributionElectricity",
        component: () =>
          import("@/views/business/base/distributionElectricity/index"),
      },
      // 东府-高
      {
        path: "dongfu-high",
        component: () =>
          import("@/views/business/base/distributionElectricity/dongfuHigh"),
      },
      // 东府-低
      {
        path: "dongfu-low",
        component: () =>
          import("@/views/business/base/distributionElectricity/dongfuLow"),
      },
      // 西府-低
      {
        path: "xifu-low",
        component: () =>
          import("@/views/business/base/distributionElectricity/xifuLow"),
      },
      // 西府-高
      {
        path: "xifu-high",
        component: () =>
          import("@/views/business/base/distributionElectricity/xifuHigh"),
      },
      // 容郡-商业-高
      {
        path: "rongjun-high",
        component: () =>
          import("@/views/business/base/distributionElectricity/rongjunHigh"),
      },
      // 容郡-住宅-高
      {
        path: "rongjun-home-high",
        component: () =>
          import("@/views/business/base/distributionElectricity/rongjunHomeHigh"),
      },
      // 容郡-住宅-列表
      {
        path: "rongjun-home-list",
        component: () =>
          import("@/views/business/base/distributionElectricity/rongjunHomeList"),
      },
      // 容郡-列表
      {
        path: "rongjun-list",
        component: () =>
          import("@/views/business/base/distributionElectricity/rongjunList"),
      },
      // rongjunHomeList
      // 容郡-低
      {
        path: "rongjun-low",
        component: () =>
          import("@/views/business/base/distributionElectricity/rongjunLow"),
      },
      // 东府配电室
      {
        path: "dongfu-high-list",
        component: () =>
          import("@/views/business/base/distributionElectricity/dongfuHighList"),
      },
      // 西府配电室
      {
        path: "xifu-high-list",
        component: () =>
          import("@/views/business/base/distributionElectricity/xifuHighList"),
      }
    ],
  },
  // 定时任务
  {
    path: "/schedule",
    component: Layout,
    redirect: "/schedule/index",
    children: [
      {
        path: "index",
        name: "schedule",
        component: () =>
          import("@/views/business/base/schedule/index"),
      },
    ],
  },
  // 空调模组
  {
    path: "/airModule",
    component: Layout,
    redirect: "/airModule/index",
    children: [
      {
        path: "index",
        name: "airModule",
        component: () =>
          import("@/views/business/base/airModule/map"),
      },
    ],
  }
];

export default ZiGuiRouter;
